import React from "react";
import {
  withStyles,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip
} from "material-ui";
import { Close } from "material-ui-icons";
import PropTypes from "prop-types";
import tasksStyle from "../variables/styles/tasksStyle";
import {getFormattedDateForTitle} from "../../../../../utils/date";
import UnreadAlert from "../../../recordings/recordingcard/information/UnreadAlert";

/**
 * Unread subsection of notifications to be displayed on a notifications window.
 */
class UnreadNotifications extends React.Component {
    render() {
        const { classes, notifications } = this.props;
        return (
            <Table className={classes.table}>
                <TableBody>
                    {notifications.map(recording => (
                        <TableRow key={recording.recordingID} className={classes.tableRow}>
                            <TableCell className={classes.tableCell}>
                                <UnreadAlert/>
                                {getFormattedDateForTitle(recording.date)}
                            </TableCell>
                            <TableCell className={classes.tableActions}>
                                <Tooltip
                                    id="tooltip-top-start"
                                    title="Mark as read"
                                    placement="top"
                                    classes={{ tooltip: classes.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Close"
                                        className={classes.tableActionButton}
                                    >
                                        <Close
                                            className={
                                                classes.tableActionButtonIcon + " " + classes.close
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        );
    }
}

UnreadNotifications.propTypes = {
    classes: PropTypes.object.isRequired,
    notifications: PropTypes.arrayOf(PropTypes.object)
};

export default withStyles(tasksStyle)(UnreadNotifications);



// WEBPACK FOOTER //
// ./src/components/unit/summary/cards/notifications/UnreadNotifications.jsx